module.exports = __webpack_public_path__ + "img/sheet.c587f4cc.svg";